import eventHubFactory from '~/helpers/event_hub_factory';

export const EVENT_RESPONSIVE_TOGGLE = 'top-nav-responsive-toggle';

export default eventHubFactory();
